import React, { useState } from 'react';

export default function ContactForm({ variant }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "919152023390"; // Your WhatsApp number (without +)
    const message = `🌞 *Contact Inquiry from Website* 🌞

*Name:* ${formData.name}
*Email:* ${formData.email}
*Message:* ${formData.message}

Please contact this person.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // Opens WhatsApp in new tab

    // Reset form
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <form
      onSubmit={handleSubmit} // ✅ Submit to WhatsApp
      className={`cs_contact_form bg-white cs_pt_64 cs_pl_80 cs_pr_80 cs_pb_80 cs_pl_lg_30 cs_pr_lg_30 position-relative cs_rounded_20 ${
        variant ? variant : ''
      }`}
      style={{ backgroundImage: `url('/images/contact_bg_pattern.svg')` }}
    >
      <div className="cs_section_heading cs_style_1 d-flex align-items-center text-center cs_mb_30">
        <div className="cs_section_heading_in">
          <h2 className="cs_fs_48 cs_fs_lg_36 m-0">Contact Us</h2>
        </div>
      </div>

      <input
        name="name"
        value={formData.name}
        onChange={handleChange}
        className="form-control cs_fs_14 cs_rounded_5 border-0 cs_mb_15 bg-gray"
        type="text"
        placeholder="Your Name"
        required
      />
      <input
        name="email"
        value={formData.email}
        onChange={handleChange}
        className="form-control cs_fs_14 cs_rounded_5 border-0 cs_mb_15 bg-gray"
        type="email"
        placeholder="Your Email"
        required
      />
      <textarea
        name="message"
        value={formData.message}
        onChange={handleChange}
        className="form-control cs_fs_14 cs_rounded_5 border-0 cs_mb_30 bg-gray"
        placeholder="Message here ..."
        cols={30}
        rows={4}
        required
      />
      <button className="cs_btn cs_style_1 cs_fs_16 cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_10 cs_pb_10 overflow-hidden">
        <span>Submit Now</span>
      </button>
    </form>
  );
}
